import React from 'react';
import $ from 'jquery';

const GetDomains = () => {
    let data = { projectId: localStorage.getItem("currentProjectId") }
    var isResponseTrue = false;
    var treeData;
    $.ajax({
        url: "/api/project-categories",
        type: 'GET',
        async: false,
        headers: {
            "Authorization": "Bearer" + localStorage.getItem("access_token")
        },
        data: data,
        success: function (res) {
            if (res.success === true) {
                treeData = createTreeList(res["result"]);
                isResponseTrue = true;
            }
        }
    });
    if (isResponseTrue) {
        return treeData;
    }
}
const createTree = (data) => {
    var idRowMap = [];
    var levelMap = [];
    var domain;
    var parentDomain;
    var topLevel = [];
    const nullParent = "00000000-0000-0000-0000-000000000000";

    for (var i = 0; i < data.length; i++) {
        domain = data[i];
        idRowMap[domain.id] = domain;
        domain._subRows = [];

        if (domain.parentId == nullParent) {
            topLevel.push(domain);
            domain.level = 0;
        }
    }

    for (var i = 0; i < data.length; i++) {
        domain = data[i];
        if (domain.parentId != nullParent) {
            try {
                parentDomain = idRowMap[domain.parentId];
                parentDomain._subRows.push(domain);
            } catch (e) {
                console.log("Could not find parent with id : ", domain.parentId);
            }
        }
    }

    for (var i=0; i < topLevel.length; i++) {
        findLevels(topLevel[i]);
    }

    
    return topLevel;
}

function findLevels(node) {
    var child;
    for (var i = 0; i < node._subRows.length; i++) {
        child = node._subRows[i];
        child.level = node.level + 1;
        findLevels(child);
    }
}

export const createTreeList = (data) => {
    var parentNodes = createTree(data);
    var resultArray = [];
    for (var i in parentNodes) {
        collectNode(resultArray, parentNodes[i]);
    }

    return resultArray;
}

const indent = " \u00A0 \u00A0 \u00A0 ";
const collectNode = (nodeArray, node) => {
    var totalIndent = "";
    for (var i = 0; i < node.level; i++) {
        totalIndent += indent;
    }

    node.displayValue = totalIndent + "↪" + node.name;
    nodeArray.push({ "domain": node.displayValue, "domainId": node.id });


    for (var subNode in node._subRows) {
        collectNode(nodeArray, node._subRows[subNode]);
    }

    delete (node._subRows);
}

export default GetDomains;


// WEBPACK FOOTER //
// ./src/projectmgmt/GetDomains.js